/* global URI */
angular.
module("dx.webapp.api").
factory("dxApiV1GradesSpreadsheet", function dxApiV1GradesSpreadsheetService() {
	"use strict";

	function gradesSpreadsheetUrl(examId, indicateUnanswered, orderBy) {
		var url = new URI("/api/v1/exams/" + examId + "/excel");

		if (indicateUnanswered) {
			url = url.setSearch("indicateUnanswered", "true");
		}

		if (orderBy) {
			var orderByStr = (orderBy.reverse ? "-" : "") + orderBy.predicate;
			url = url.setSearch("orderBy", orderByStr);
		}

		return url.toString();
	}

	return {
		url: gradesSpreadsheetUrl,
	};
});
